import { render, staticRenderFns } from "./ClosedCardPlayground.vue?vue&type=template&id=713e831b&scoped=true&"
import script from "./ClosedCardPlayground.vue?vue&type=script&lang=js&"
export * from "./ClosedCardPlayground.vue?vue&type=script&lang=js&"
import style0 from "./ClosedCardPlayground.vue?vue&type=style&index=0&id=713e831b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713e831b",
  null
  
)

export default component.exports